import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
import Dropdown from 'components/dropdown'
import { sortingDropdown } from '../common/options'
import { MORTGAGE_SORTING_FORM_NAME } from '../common/constants'

/*
  Basic redux form to handle the sorting of product results.
*/
const SortingForm = ({ className }) => (
  <form className={className} onSubmit={() => {}}>
    <Dropdown
      label="Order by"
      name="sorting"
      options={sortingDropdown}
      icon={false}
    />
  </form>
)

SortingForm.propTypes = {
  className: PropTypes.string,
}
export default reduxForm({
  form: MORTGAGE_SORTING_FORM_NAME,
  initialValues: true,
  enableReinitialize: true,
})(SortingForm)
